'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getList;
/**
 * Fetches a list.
 *
 * @param {string}	list Name of the list
 * @param {Object}	options
 * @param {string[]} options.fields List of fields to get
 * @param {function(item: Object): Object} options.mapper Mapper function
 *
 * @example
 * getList('List', {
 *     fields: [ 'Id', 'Title' ],
 *     mapper: function(item) {
 *         return {
 *             id: item.get_id(),
 *             title: item.get_item('Title')
 *         };
 *     }
 * })
 * .then((items) => {})
 * .catch((sender, args) => {});
 *
 * @return {Promise<Object[]>}  a list of items.
 */
function getList(list, _ref) {
    var fields = _ref.fields,
        mapper = _ref.mapper;

    var includes = fields && Array.isArray(fields) && 'Include(' + fields.join(',') + ')';

    return new Promise(function (resolve, reject) {
        window.SP.SOD.executeFunc('sp.js', 'SP.ClientContext', function () {
            var ctx = window.SP.ClientContext.get_current();
            var path = window._spPageContextInfo.webAbsoluteUrl + '/Lists/' + list;
            var items = ctx.get_web().getList(path).getItems(window.SP.CamlQuery.createAllItemsQuery());

            if (includes) {
                ctx.load(items, includes);
            } else {
                ctx.load(items);
            }

            ctx.executeQueryAsync(function () {
                var result = items.get_data();
                if (typeof mapper === "function") {
                    resolve(result.map(mapper));
                } else {
                    resolve(result);
                }
            }, function (sender, args) {
                reject(sender, args);
            });
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/getList.js
// module id = 1041
// module chunks = 0